export const MEDIA_QUERY_1279 = "@media screen and (max-width: 1279px)";
export const MEDIA_QUERY_480 = "@media screen and (max-width: 480px)";
export const MEDIA_QUERY_360 = "@media screen and (max-width: 360px)";
